import { render, staticRenderFns } from "./OrganizStudentRegister.vue?vue&type=template&id=b9a83bdc&scoped=true&"
import script from "./OrganizStudentRegister.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizStudentRegister.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizStudentRegister.vue?vue&type=style&index=0&id=b9a83bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a83bdc",
  null
  
)

export default component.exports